module.exports = __webpack_public_path__ + "static/media/Medline.5cf1a7c9.png";